import PropTypes from 'prop-types';
import ProductGroupStep from '../ProductGroupStep/ProductGroupStep';

export default function Mirrors({
    surfaceName = 'Mirror',
    stepIndex,
    room = '',
    onViewAllApplied,
    onNext,
    onPrevious
}) {
    return (
        <ProductGroupStep
            title="Mirrors"
            stepName="Mirrors"
            seriesId="9787"
            surfaceName={surfaceName}
            stepIndex={stepIndex}
            room={room}
            onViewAllApplied={onViewAllApplied}
            onNext={onNext}
            onPrevious={onPrevious}
        />
    );
}

Mirrors.propTypes = {
    surfaceName: PropTypes.string,
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
